import { ActionIcon, Box, Card, Group, Loader, Modal, Text, Tooltip, Transition } from '@mantine/core';
import { getDocument, GlobalWorkerOptions, PDFDocumentProxy } from 'pdfjs-dist';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEmbeddingFile } from '@mygpt/app/chat/services';
import { headerToken } from '@mygpt/app/apis';
import { useFilePreviewStore } from '@mygpt/app/chat/stores/useFilePreviewStore';
import { PDFPreviewList } from './List';
import { Toaster } from 'react-hot-toast';

export const Content = ({ fitWidth = false }: { fitWidth?: boolean }) => {
  const { t } = useTranslation();
  const { file_id, page: referencePage } = useFilePreviewStore();
  // 记录PDF页面的总数
  // 记录是否已经滚动到
  const [loadedPDF, setLoadedPDF] = useState<{
    pdf: PDFDocumentProxy;
    fileURL: string;
  }>();

  const fileURL = useMemo(() => {
    if (!file_id) return '';
    return getEmbeddingFile({ file_id: file_id, to_pdf: true });
  }, [file_id]);

  useEffect(() => {
    if (!fileURL) {
      return;
    }

    // pdf.js 自己发请求，不经过 axios 拦截器，需手动带上登录 token；
    // 匿名访客（公开 bot 的 widget / web）没有 token，由后端按 bot 公开性放行
    const token = headerToken();
    const loadingTask = getDocument({
      url: fileURL,
      ...(token ? { httpHeaders: { Authorization: token } } : {}),
      cMapUrl: '/cmaps/',
      cMapPacked: true,
    });

    loadingTask.promise.then((pdf) => {
      setLoadedPDF({
        pdf,
        fileURL,
      });
    });
  }, [fileURL, t]);

  // 如果pdf没有加载完成，或者已加载的pdf url和当前最新的 fileURL 不一致，说明用户又打开了新的文件，但新文件还未加载完成
  if (!loadedPDF || !loadedPDF.pdf || loadedPDF?.fileURL !== fileURL) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <Loader color="blue" size="sm" />
        <Text size="sm" fw={500} mt={10}>
          {t('pdf_viewer.loading')}
        </Text>
      </div>
    );
  }

  return (
    <>
      <PDFPreviewList pdf={loadedPDF.pdf} defaultPageIndex={referencePage} fitWidth={fitWidth} />
      <Toaster toasterId="FILE_PREVIEW" />
    </>
  );
};
